import React from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const CostiAnalisiKPISet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const { getComparableTimeframe } = useDates();

    return (drawable &&
        <Box className="mtska-kpi-set" sx={{ marginBottom: '0px' }}>
            <KPI
                title="Costs"
                dataProviderName={'statisticsviews/item/sumfinancial/advertisings/advertisingCost/value'}
                format="currency"
                compactformat={false}
                filters={filterModel}
                compareFilters={
                    {
                        ...getComparableTimeframe(filterModel, 'registered_at'), 
                        timeline: {
                            collection:'views_advertisings_advertisingcost',
                            field:'registered_at',
                            granularity:'month',
                            sumfield:'value',
                            cast:'financial'
                        }
                    }
                }
                comparePositiveCondition={'inverse'}
            />
        </Box>
    )
}

export default CostiAnalisiKPISet;
